import googleTagLinker from "./libs/google-tag-linker";

const GOOGLE_ANALYTICS_FOUR_PARAMETER = "_gl";
const CUSTOM_SESSION_ID = "custom_session_id";

const getCookie = (cname) => {
  const name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const GA4linkerParam = googleTagLinker("get");

export const addGA4LinkerParamToUrl = (url) => {
  try {
    if (typeof GA4linkerParam !== "string") {
      return url;
    }
    if (!GA4linkerParam) {
      return url;
    }
    const newURL = new URL(url);
    if (newURL.searchParams.has(GOOGLE_ANALYTICS_FOUR_PARAMETER)) {
      newURL.searchParams.set(GOOGLE_ANALYTICS_FOUR_PARAMETER, GA4linkerParam);
    } else {
      newURL.searchParams.append(
        GOOGLE_ANALYTICS_FOUR_PARAMETER,
        GA4linkerParam
      );
    }

    const customSessionId = getCookie(CUSTOM_SESSION_ID) || "";
    if (customSessionId) {
      newURL.searchParams.append(CUSTOM_SESSION_ID, customSessionId);
    }

    return newURL.href;
  } catch (error) {
    return url;
  }
};
